module.exports = __webpack_public_path__ + "static/img/product07.e93f959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product07.png
// module id = SPfJ
// module chunks = 1